/*
 * @Author: YuanYuan
 * @Date: 2024-02-04 19:44:22
 * @LastEditTime: 2026-05-29 16:02:21
 * @Description: 多语言配置文件
 */
import Vue from 'vue'
import VueI18n from 'vue-i18n'
import zh from './zh'
import en from './en'
import ja from './ja'
import ko from './ko'
import Cookies from 'js-cookie'
import { setLangCookies } from '@/utils/lang'

Vue.use(VueI18n)

const browserLang = (navigator.language || navigator.userLanguage || '').toLowerCase()
const browserLocale = (browserLang === 'zh-cn' || browserLang === 'zh') ? 'cn_CN' : 'en_CN'

let language = Cookies.get('__lclcookie') || browserLocale

if (process.env.NODE_ENV === 'development') {
  language = 'cn_CN'
  // language = 'en_CN'
}

// 若 Cookie 不存在，将默认语言同步写入，确保 waap 等子系统能读到正确的语言值
if (!Cookies.get('__lclcookie')) {
  setLangCookies(language)
}


export const lang = language

const i18n = new VueI18n({
  locale: lang,
  fallbackLocale: 'en_CN',
  silentFallbackWarn: true,
  messages: {
    'cn_CN': {
      ...zh,
      ...window.ELEMENT.lang.zhCN
    },
    'en_CN': {
      ...en,
      ...window.ELEMENT.lang.en
    },
    'ja-jp': {
      ...ja,
      ...window.ELEMENT.lang.ja
    },
    'ko-kr': {
      ...ko,
      ...window.ELEMENT.lang.ko
    }
  }
})

export default i18n
